import React, { useState } from "react";
import { ListInput, SelectMenu, TextInput } from "@raketa-cms/raketa-cms";

const ListItem = ({ settings, countries, onChangeItem }) => (
  <div>
    <SelectMenu
      label="Country"
      options={countries}
      value={settings.country}
      onChange={(value) => onChangeItem("country", value)}
    />

    <TextInput
      label="Disclaimer"
      onChange={(value) => onChangeItem("disclaimer", value)}
      value={settings.disclaimer}
    />

    <TextInput
      label="Additional disclaimer"
      onChange={(value) => onChangeItem("additional_disclaimer", value)}
      value={settings.additional_disclaimer}
    />
  </div>
);

const PricingCountryDisclaimers = ({ value, name, countries }) => {
  const [items, setItems] = useState(value);

  return (
    <div className="field-pannel form-group">
      <ListInput
        label="Country disclaimers"
        listItem={(settings, onChangeItem, idx) => (
          <ListItem
            idx={idx}
            settings={settings}
            countries={countries}
            onChangeItem={onChangeItem}
          />
        )}
        primaryField="country"
        onChangeList={(_, newItems) => setItems(newItems)}
        items={items}
        template={{ country: "", disclaimer: "", additional_disclaimer: "" }}
      />

      <input type="hidden" name={name} value={JSON.stringify(items)} />

      <span className="help-block">
        Adding a country here will override the global disclaier and additional
        disclaimer for the pricing.
      </span>
    </div>
  );
};

export default PricingCountryDisclaimers;
